import React, {Fragment} from 'react';
import {Alert} from 'reactstrap';
import {connect} from 'react-redux';
import ReactTooltip from 'react-tooltip';
import TagsList from '../../../shared/components/TagsList';

const TaskGroupTable = (props) => {
  // ----------------------
  // Computed
  // ----------------------

  function getCanArchive(taskGroup) {
    return (
      taskGroup.status === 'current' &&
      props.userContext.hasScope(['depadmin', 'admin'])
    );
  }

  function getCanClone(taskGroup) {
    if (taskGroup.status !== 'current') {
      return false;
    }
    return props.userContext.hasScope(['depadmin', 'admin']);
  }

  function getCanEditOrActivate(taskGroup) {
    return (
      taskGroup.status === 'draft' &&
      props.userContext.hasScope(['depadmin', 'admin'])
    );
  }

  function getStatusBadgeClasses(statusString) {
    return statusString === 'revised'
      ? 'badge badge-primary'
      : 'badge badge-secondary';
  }

  function getTaskGroupsSorted(taskGroups) {
    let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

    return taskGroups.sort(function (a, b) {
      return collator.compare(a.name, b.name)
      // if (a.name < b.name) {
      //   return -1;
      // }
      // if (a.name > b.name) {
      //   return 1;
      // }
      // return 0;
    })

  }

  const getTasksCount = (taskGroupMap, taskGroup) => {
    let subGroups = props && props.taskGroupMap && props.taskGroupMap[taskGroup.taskGroupGuid] && props.taskGroupMap[taskGroup.taskGroupGuid].subGroups || []
    return taskGroup.tasks.length + subGroups.reduce((sum, tg) => sum + tg.tasks.length,0)
  }

  // ----------------------
  // Render
  // ----------------------

  let taskGroups = getTaskGroupsSorted(props.taskGroups);
  let taskGroupsMap = props.taskGroupsMap;
  return (
    <Fragment>
      {!taskGroups.length ? (
        <Alert color="primary">No Task Groups for selected filters</Alert>
      ) : (
        <div className="table-scrollable">
          <table className="table table-stripped layout-auto">
            <thead>
            <tr>
              <th>
                <div className="header">
                  <span>Name </span>
                </div>
              </th>
              <th>
                <div className="header">
                  <span>Tasks Count </span>
                </div>
              </th>
              <th>
                <div className="header">
                  <span>Status </span>
                </div>
              </th>
              <th>
                <div className="header">
                  <span>Tags </span>
                </div>
              </th>
              <th>
                <div className="header">
                  <span>Actions </span>
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            {taskGroups.map((taskGroup, index) => {
              let taskCount = getTasksCount(taskGroupsMap, taskGroup)
              return (
                <tr key={index.toString()}>
                  <td>{taskGroup.name}</td>
                  <td>{taskCount}</td>
                  <td className="text-capitalize">
                    <span
                      className={getStatusBadgeClasses(taskGroup.status)}
                    >
                      {taskGroup.status}
                    </span>
                  </td>
                  <td>
                    <TagsList tags={taskGroup.tags} />
                  </td>
                  <td className="td-actions">
                    <ReactTooltip
                      className="customTheme"
                      effect="solid"
                      place="top"
                    />
                    <button
                      data-tip="Details"
                      className="button default small"
                      onClick={() => props.onShowDetails(taskGroup.taskGroupGuid)}
                    >
                      <i className="fa fa-list" />
                    </button>
                    {taskGroup.status !== 'archived' && (
                      <button
                        data-tip="Manage Tags"
                        className="button default small"
                        onClick={() => props.onManageTags(taskGroup.taskGroupGuid)}
                      >
                        <i className="fa fa-tags" />
                      </button>
                    )}
                    {getCanEditOrActivate(taskGroup) && (
                      <button
                        data-tip="Delete Draft"
                        className="button default small"
                        onClick={() => props.onDeleteTaskGroup(taskGroup.taskGroupGuid)}
                      >
                        <i className="fa fa-trash" />
                      </button>
                    )}
                    {getCanEditOrActivate(taskGroup) && (
                      <button
                        data-tip="Activate"
                        className="button default small"
                        disabled={taskCount === 0}
                        onClick={() =>
                          props.onActivateTaskGroup(taskGroup.taskGroupGuid)
                        }
                      >
                        <i className="fa fa-play-circle-o" />
                      </button>
                    )}
                    {getCanArchive(taskGroup) && (
                      <button
                        data-tip="Archive"
                        className="button default small"
                        onClick={() => props.onArchiveTaskGroup(taskGroup.taskGroupGuid)}
                      >
                        <i className="fa fa-archive" />
                      </button>
                    )}
                    {getCanClone(taskGroup) && (
                      <button
                        data-tip="Clone"
                        className="button default small"
                        onClick={() => props.onCloneTaskGroup(taskGroup.taskGroupGuid)}
                      >
                        <i className="fa fa-clone" />
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      )}
    </Fragment>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    taskGroupMap: state.taskGroups.taskGroupMap2,
    userContext: state.common.userContext
  };
};

export default connect(mapStateToProps, null)(TaskGroupTable);
